import { api } from '../services/api';
import { IDataNoPagination } from '../types/shared';

export interface IProfileUpdate {
  senha?: string;
  nova_senha?: string;
}

export const useProfile = () => {
  const updateProfile = async (data: IProfileUpdate): Promise<IDataNoPagination<any>> => {
    const res = await api.put<IDataNoPagination<any>>(`/api/v1/usuarios/perfil/`, data);
    return res.data;
  };

  return {
    updateProfile,
  };
};
